import { useTheme } from '@mui/material';
import { memo } from 'react';
import Typography from '../../../../../../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../../../../translation/TranslationContext';
import { SelloutDistribution } from '../../../types/selloutDistribution.types';

interface SelloutDistributionRowItemProps {
  skuId: string;
  disabled: boolean;
  disabledMap: Map<string, boolean>;
  distributionMap: Map<string, SelloutDistribution>;
}

const SelloutDistributionRowItem = ({
  skuId,
  disabled,
  disabledMap,
  distributionMap,
}: SelloutDistributionRowItemProps) => {
  const { translate } = useTranslation();
  const theme = useTheme();

  const found = distributionMap.get(skuId);
  const isItemDisabled = disabledMap.get(skuId);
  const disabledRowItem = disabled || !!isItemDisabled;

  return (
    <Typography
      color={disabledRowItem ? theme.palette.grey[400] : theme.palette.primary.main}
      title={
        disabledRowItem
          ? translate(LangEnum.ORDER_SELLOUT_MODAL_DISTRIBUTION_ITEM_UNAVAILABLE_FOR_SALE)
          : undefined
      }
    >
      {found?.quantityToDistribute ?? 0}
    </Typography>
  );
};

export default memo(SelloutDistributionRowItem);
